<script setup lang="ts">
const spinnerColors = [
  "white",
  "primary",
  "common",
  "uncommon",
  "rare",
  "epic",
  "legendary",
  "exotic",
  "mythic",
  "unique",
] as const;

const props = defineProps({
  size: {
    default: "md",
    validator: (value: string) => {
      return ["custom", "xs", "sm", "md", "lg", "xl", "2xl", "3xl"].includes(
        value
      );
    },
  },
  customClass: {
    type: String,
    required: false,
    default: undefined,
  },
  color: {
    type: String as PropType<(typeof spinnerColors)[number]>,
    required: false,
    default: "white",
  },
  animate: {
    type: Boolean,
    default: false,
  },
  animationInterval: {
    type: Number,
    default: 200,
  },
});

const colorIndex = ref(1);//Math.floor(Math.random() * spinnerColors.length));
const isAnimating = ref(false);

const currentColor = computed(() =>
  isAnimating.value ? spinnerColors[colorIndex.value] : props.color
);

let intervalId: NodeJS.Timeout | null = null;

onMounted(() => {
  //const randomValue = Math.random();
  const randomValue = 999;//getSecureRandomBetween(0, 1000);
  if (props.animate || randomValue < 10) {
    isAnimating.value = true;
    intervalId = setInterval(() => {
      colorIndex.value = (colorIndex.value + 1) % spinnerColors.length;
    }, props.animationInterval);
  }
});

function getSecureRandomBetween(min: number, max: number): number {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  const random = array[0] / (0xffffffff + 1); // normalize to [0,1)
  return Math.floor(random * (max - min + 1)) + min;
}

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});

const colorToTailwind = computed(() => {
  switch (currentColor.value) {
    case "white":
      return "text-neutral-200";
    case "primary":
      return "text-primary-500";
    case "common":
      return "text-rarity-common";
    case "uncommon":
      return "text-rarity-uncommon";
    case "rare":
      return "text-rarity-rare";
    case "epic":
      return "text-rarity-epic";
    case "unique":
      return "text-rarity-unique";
    case "legendary":
      return "text-rarity-legendary";
    case "exotic":
      return "text-rarity-exotic";
    case "mythic":
      return "text-rarity-mythic";
    default:
      return "text-neutral-200";
  }
});
const extraClasses = computed(() => {
  switch (props.size) {
    case "custom":
      return [props.customClass];
    case "xs":
      return ["w-2 h-2"];
    case "sm":
      return ["w-4 h-4"];
    case "lg":
      return ["w-6 h-6"];
    case "xl":
      return ["w-12 h-12"];
    case "2xl":
      return ["w-24 h-24"];
    case "3xl":
      return ["w-36 h-36"];
    default:
      return ["w-6 h-6"];
  }
});
</script>

<template>
  <div role="status" class="flex items-center justify-center">
    <NuxtIcon
      name="svg-spinners:ring-resize"
      :alt="$t('main.imageAltTexts.loading')"
      :class="[
        extraClasses,
        colorToTailwind,
        'transition-colors duration-300',
      ]" />
    <span class="sr-only">{{ $t("main.loaderSpinner.loading") }}</span>
  </div>
</template>
